/* Free gift with purchase: AuraTint 1-pack (variant 43700767424579) added
   free once the cart reaches GH₵250, excluding AuraTint's own line(s) from
   that GH₵250 — matches the "Free AuraTint Gift — Orders GH₵250+" automatic
   discount's own customer-buys rule exactly (that discount excludes AuraTint
   from its qualifying product list for the same reason: so buying AuraTint
   itself can't be used to unlock a free AuraTint).

   Self-contained. Does not read or modify presura.js — it only observes
   fetch() calls to the cart endpoints, so it reacts the same way no matter
   what triggered the change (PDP add, drawer qty step, cart page, or this
   script's own add/remove). If AuraTint's variant ID, product ID or the
   GH₵250 threshold ever change, update the three constants below AND the
   matching ones in snippets/gift-progress-bar.liquid together. */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 43700767424579;   // AuraTint — Aloe Colour-Changing Lip Balm, 1-pack
  var GIFT_PRODUCT_ID = 7808118227011;    // AuraTint product — excluded from its own threshold
  var THRESHOLD_CENTS = 25000;            // GH₵250.00
  var GIFT_FLAG = '_free_gift';           // line property marking OUR auto-added line

  var syncing = false;
  var pending = false;

  function eligibleSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (line) {
      if (line.product_id !== GIFT_PRODUCT_ID) total += line.original_line_price;
    });
    return total;
  }

  function findAutoGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i];
      if (line.variant_id === GIFT_VARIANT_ID && line.properties && line.properties[GIFT_FLAG] === '1') {
        return line;
      }
    }
    return null;
  }

  function money(cents) {
    var fmt = (window.PresuraShop && window.PresuraShop.moneyFormat) || 'GH₵{{amount}}';
    var amount = Math.max(0, cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, amount).replace(/<[^>]*>/g, '');
  }

  function renderProgress(cart) {
    document.querySelectorAll('[data-gift-progress]').forEach(function (el) {
      var remaining = THRESHOLD_CENTS - eligibleSubtotal(cart);
      var top = el.querySelector('.ship-bar__top');
      if (!top) return;
      if (remaining <= 0) {
        el.classList.add('is-done');
        top.innerHTML = '';
        var done = document.createElement('b');
        done.style.cssText = 'display:flex;align-items:center;gap:8px';
        done.textContent = el.getAttribute('data-gift-done-label') || 'Free gift added to your bag';
        top.appendChild(done);
      } else {
        el.classList.remove('is-done');
        var label = (el.getAttribute('data-gift-progress-label') || '{amount} more for a free gift').replace('{amount}', money(remaining));
        top.innerHTML = '';
        var b = document.createElement('b');
        b.textContent = label;
        top.appendChild(b);
      }
      var fill = el.querySelector('.ship-bar__fill');
      if (fill) {
        var pct = Math.min(100, (eligibleSubtotal(cart) * 100) / THRESHOLD_CENTS);
        fill.style.width = pct + '%';
      }
    });
  }

  function refreshDrawerUi(cart) {
    fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-inner]');
        var target = document.querySelector('[data-drawer] [data-drawer-inner]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        renderProgress(cart);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  function sync() {
    if (syncing) { pending = true; return; }
    syncing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qualifies = eligibleSubtotal(cart) >= THRESHOLD_CENTS;
        var giftLine = findAutoGiftLine(cart);

        if (qualifies && !giftLine) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _free_gift: '1' } }] })
          }).then(function () { return true; });
        }
        if (!qualifies && giftLine) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 0 })
          }).then(function () { return true; });
        }
        return false;
      })
      .catch(function () { /* fail silent: worst case the gift lags a beat behind the cart */ })
      .then(function (changed) {
        syncing = false;
        if (pending) { pending = false; sync(); return; }
        if (changed) {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(refreshDrawerUi);
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(renderProgress);
        }
      });
  }

  /* Observe every cart write regardless of which script made it, instead of
     hooking presura.js's own DOM events — keeps this file fully independent
     of that one. */
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartWrite = /\/cart\/(add|change|update|clear)\.js/.test(url);
    var result = nativeFetch.apply(this, arguments);
    if (isCartWrite) result.then(function () { setTimeout(sync, 50); }).catch(function () {});
    return result;
  };

  document.addEventListener('DOMContentLoaded', sync);
})();
